export const environment = {
  production: true,
  API_BASE_URL: 'https://www.vittal.com.ar',
  dopplerApiUrl: 'YOUR_DOPPLER_API_URL',
  dopplerApiKey: 'YOUR_DOPPLER_API_KEY',
  googleAnalyticsId: 'YOUR_GA_ID'
};
